<template>
    <el-form ref="vehicleform" :model="vehicleInfo" :rules="rules" class="management-content" label-width="145px"
             label-position="left">
        <table class="management-table">
            <thead>
            <td colspan="3" class="management-content-title"> {{$t('vehicle.vehicleInformation')}}</td>
            </thead>
            <tr>
                <td>
                    <el-form-item prop="Name" :label="$t('vehicle.vehicleName')" :label-width="width.column1">
                        <el-input v-model="vehicleInfo.Name" size="small" class="text-value-input"></el-input>
                    </el-form-item>
                </td>
                <td>
                    <el-form-item prop="Id" :label="$t('vehicle.plateNumber')" :label-width="width.column2">
                        <el-input v-model="vehicleInfo.Id" size="small"
                                  class="text-value-input uppercase-input"></el-input>
                    </el-form-item>
                </td>
                <td>
                    <el-form-item :label="$t('vehicle.fleet')" prop="Fleet" :label-width="width.column3">
                        <el-select v-model="vehicleInfo.Fleet"
                                   value-key="Id"
                                   size="small"
                                   class="text-value-input-append"
                                   :placeholder="$t('tips.vehicles.select')"
                        >
                            <el-option v-for="(item) in fleetList"
                                       :value="item"
                                       :label="item.Name"
                                       :key="item.Id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>

                </td>
            </tr>
            <tr>
                <td>
                    <el-form-item :label="$t('vehicle.vehicleModel')" prop="VehicleModelId" :label-width="width.column1">
                       <model-selector v-model="vehicleInfo.VehicleModelId"  @change="handleModelChange"></model-selector>
                    </el-form-item>
                </td>

                <td>
                    <el-form-item :label="$t('vehicle.fuelTankCapacity')"
                                  :label-width="width.column2">
                        <el-input v-model.trim="FuelTankCapacityShow" size="small" disabled
                                  class="text-value-input-append">
                            <template slot="append">{{unitLiter}}</template>
                        </el-input>
                    </el-form-item>
                </td>
                <td>
                    <el-form-item :label="$t('vehicle.fuelType')" :label-width="width.column3">
                        <el-input v-model="vehicleInfo.FuelType" size="small" class="text-value-input" disabled></el-input>
                    </el-form-item>
                </td>
            </tr>
            <tr>
                <td>
                    <el-form-item :label="$t('vehicle.vehicleWeight')" :label-width="width.column1">
                        <el-input v-model="vehicleInfo.Weight" size="small" class="text-value-input" disabled></el-input>
                    </el-form-item>
                </td>
                <td>
                    <el-form-item  :label="$t('vehicle.displacement')"
                                  :label-width="width.column2">
                        <el-input v-model.trim="DisplacementShow" size="small" class="text-value-input-append" disabled>
                            <template slot="append">{{unitLCC}}</template>
                        </el-input>
                    </el-form-item>
                </td>
                <td></td>
            </tr>
            <tr>
                <td colspan="3">
                    <el-form-item class="license-area" :label-width="width.column1">
                        <div slot="label">{{$t('vehicle.vehicleLicense')}}</div>
                        <v-upload v-if="vehicleInfo.LicensePath" :file="getImagePath(vehicleInfo.LicensePath)"
                                  @selectFile="selectLicense"></v-upload>
                        <v-upload v-else @selectFile="selectLicense"></v-upload>
                    </el-form-item>
                </td>
            </tr>
            <tr>
                <td colspan="3">
                    <el-form-item class="driver-area" :label-width="width.column1">
                        <div slot="label">{{$t('vehicle.permittedDrivers')}}</div>
                        <v-driver-mult-select :default-drivers="vehicleInfo.Drivers"
                                              @selectDriver="handleSelectDriver"></v-driver-mult-select>
                    </el-form-item>

                </td>
            </tr>
        </table>

        <table class="management-table">
            <thead>
            <td colspan="3" class="management-content-title">{{$t('vehicle.AIFeatures')}}</td>
            </thead>
            <tr v-if="!isM810OrM820">
                <td v-if="devicePlatform !== 'M800'">
                    <el-form-item :label="$t('vehicle.driverSeat')" >
                        <el-input size="small" class="text-value-input-extra"
                                  :value="vehicleInfo.DriverSide != null ? vehicleInfo.DriverSide ?$t('vehicle.right'):$t('vehicle.left') : ''" disabled></el-input>
                    </el-form-item>
                </td>
                <td>
                    <el-form-item :label="$t('vehicle.vehicleWidth')" >
                        <el-input size="small" class="text-value-input-extra"
                                  v-model="VehicleWidthShow" disabled>
                            <template slot="append">{{unitCm}}</template>
                        </el-input>
                    </el-form-item>
                </td>
                <td>
                    <el-form-item :label="$t('vehicle.hoodLength')"
                                  >
                        <el-input size="small" class="text-value-input-extra"
                                  v-model="HoodLengthShow" disabled>
                            <template slot="append">{{unitCm}}</template>
                        </el-input>
                    </el-form-item>
                </td>
            </tr>
            <tr>
                <td>
                    <el-form-item :label="$t('login.alertLanguage')" >
                        <el-select size="small" class="text-value-input language-select-class" v-model="lang">
                            <el-option
                                    v-for="item in language"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </td>
                <td></td>
            </tr>
        </table>
        <div class="button-row">
            <el-button size="small" class="ok-button" style="width: 150px" @click="onSave" :loading="isSaving">
                {{$t('globalText.save')}}
            </el-button>
            <el-button size="small" class="cancel-button" @click="onCancel">{{$t('globalText.cancel')}}</el-button>
        </div>
    </el-form>
</template>


<script>
    import vUpload from '../../../components/common/Upload'
    import vDriverMultSelect from '../../../components/management/DriverMultSelect'
    import regExp from "../../../assets/js/RegExp"
    import {numRound} from "@/assets/js/Util"
    import ModelSelector from "../../../components/management/ModelSelector";


    export default {
        name: "AddVehicle",
        components: {
            ModelSelector,
            vUpload, vDriverMultSelect
        },
        data() {
            var checkFleet = (rule, value, callback) => {
                if (!this.vehicleInfo.Fleet.Id) {
                    callback(new Error('Please select fleet'));
                } else {
                    callback();
                }
            };
            return {
                lang: this.$i18n.locale,
                language: [
                    {
                        value: "en-US",
                        label: "English"
                    },
                    {
                      value: "ja-JP",
                      label: "日本語"
                    },
                    {
                        value: "zh-CN",
                        label: "中文简体"
                    },
                    {
                        value: "zh-TW",
                        label: "中文繁體"
                    }
                ],
                isSaving: false,
                isM810OrM820: false,
                devicePlatform: '',
                width: {
                    column1: '128px',
                    column1_extra: '270px',
                    column2: '151px',
                    column2_extra: '215px',
                    column3: '100px'
                },
                rules: {
                    Name: [
                        {
                            required: true,
                            message: this.$t('tips.vehicles.pleaseInputAVehicleName'),
                            trigger: ['change', 'blur']
                        },
                        {
                            min: 1,
                            max: 15,
                            message: this.$t('globalText.aMaximumOf_X_CharactersCanBeUsed', {num: 15}), // 'A maximum of 15 characters can be used',
                            trigger: ['change', 'blur']
                        }
                    ],
                    Id: [
                        {
                            required: true,
                            message: this.$t('tips.vehicles.pleaseInputAPlateNumber'), // 'Please input a plate number',
                            trigger: ['change', 'blur']
                        },
                        {
                            min: 1,
                            max: 20,
                            message: this.$t('globalText.aMaximumOf_X_CharactersCanBeUsed', {num: 20}), // 'A maximum of 10 characters can be used',
                            trigger: ['change', 'blur']
                        },
                        {validator: regExp.checkPlateNumber, trigger: ['change', 'blur']}
                    ],
                    VehicleModelId: [
                        {
                            required:true,
                            message: this.$t('vehicleModel.pleaseSelectVehicleModel'), // 'A maximum of 15 characters can be used',
                            trigger: ['change']
                        }
                    ],
                    Fleet: [
                        {required: true, trigger: 'blur'},
                        {validator: checkFleet, trigger: 'change'}
                    ]
                },
                vehicleInfo: {
                    Name: "",
                    Id: '',
                    Fleet: {
                        Id: "", Name: "",
                    },
                    VehicleModelId: '',
                    ModelName:'',
                    Capacity: '',
                    DriverIds: [],
                    Drivers: [],
                    Status: '',
                    FuelType: '',
                    SIM: '',
                    VIN: '',
                    DeviceId: '',
                    LicensePath: '',
                    BusinessPermitsPath: '',
                    Weight: '',
                    FuelTankCapacity: null,
                    Displacement: null,
                    VehicleWidth: null,
                    HoodLength: null,
                    DriverSide: null,
                    HasDevice: false,
                    Device: {
                        LDW: false,
                        FCW: false,
                        DMS: false,
                        ADASCalibrated: false,
                        DMSCalibrated: false,
                        DeviceModel: ''
                    }
                },
                FuelTankCapacityShow: null,
                DisplacementShow: null,
                VehicleWidthShow: null,
                HoodLengthShow: null,
                unAssignedFleet: {
                    Id: "UnassignedVehicles",
                    Name: this.$t('fleet.unassignedVehicles') // "Unassigned Vehicles"
                }
            };
        },
        computed: {
            fleetList: function () {
                let list = this.$store.getters.getAllFleets(true);
                let newList = [];
                if (list) {
                    list.forEach(item => {
                        if (item.Id !== this.unAssignedFleet.Id && item.Name !== this.unAssignedFleet.Name) {
                            newList.push({
                                Id: item.Id,
                                Name: item.Name
                            });
                        }
                    });
                    newList.push(this.unAssignedFleet);
                }
                return newList;
            },
            currentUnitType() {
                return this.$store.getters.unit;
            },
            unitLiter() {
                return this.$unit.getLUnit(this);
            },
            unitLCC() {
                return this.$unit.getLOrCIDUnit(this);
            },
            unitCm() {
                return this.$unit.getCmUnit(this);
            },
        },
        methods: {
            onSave() {
                let successCallback = () => {
                    this.isSaving = false;
                    this.$message(
                        {
                            message: this.$t('globalText.savedSuccessfully'),
                            type: 'success'
                        }
                    );
                    this.$router.go(-1);
                };
                let errorCallback = (error) => {
                    this.isSaving = false;
                    if (error.code === 602) {
                        let msg = this.$t('popUpMsg.vehicles.vehicleName_AlreadyExists', {
                            vehicleName: this.vehicleInfo.Name.trim()
                        }); // `${this.vehicleInfo.Name.trim()} already exists.`
                        this.$customAlert(msg);
                    }
                    if (error.code === 603) {
                        let msg = this.$t('popUpMsg.vehicles.thisPlateNumber_PlateNumber_AlreadyExists', {
                            plateNumber: this.vehicleInfo.Id
                        });
                        this.$customAlert(msg);
                    }
                };
                this.$refs['vehicleform'].validate((valid) => {
                    if (valid) {
                        this.isSaving = true;
                        let saveInfo = this.getSaveInfo();
                        this.$serverApi.vehicles.addVehicle(saveInfo, successCallback, errorCallback);
                    } else {
                        return false;
                    }
                });

            },
            getSaveInfo() {
                let saveVehicleInfo = {
                    Name: this.vehicleInfo.Name.trim(),
                    Id: this.vehicleInfo.Id.toUpperCase(),
                    FleetId: this.vehicleInfo.Fleet.Id === this.unAssignedFleet.Id ? null : this.vehicleInfo.Fleet.Id,
                    //车辆的型号
                    VehicleModelId: this.vehicleInfo.VehicleModelId,
                    Model:this.vehicleInfo.ModelName,
                    FuelTankCapacity: this.$unit.changeLiterUnitToMetric(this.FuelTankCapacityShow, this.currentUnitType),
                    FuelType: this.vehicleInfo.FuelType ? this.vehicleInfo.FuelType : null,
                    Weight: this.vehicleInfo.Weight,
                    Displacement: this.$unit.convertDisplacementToMetric(this.DisplacementShow, this.currentUnitType),
                    DriverIds: this.vehicleInfo.DriverIds,
                    AlertLanguage: this.lang

                };
                saveVehicleInfo.LicenseBase64 = this.vehicleInfo.LicenseBase64;
                saveVehicleInfo.MainModel = this.$route.query.model;//弹窗携带过来的参数
                if (!this.isM810OrM820) {
                    saveVehicleInfo.ADASWidth = this.vehicleInfo.VehicleWidth;
                    saveVehicleInfo.ADASHoodLength = this.vehicleInfo.HoodLength;
                    if (this.devicePlatform !== 'M800')
                        saveVehicleInfo.DriverLeftRight = this.vehicleInfo.DriverSide;
                }
                return saveVehicleInfo;
            },
            onCancel() {
                this.$router.go(-1);
            },
            async handleModelChange(modelId){
                let modelInfo = await this.$serverApi.model.modelData(modelId);
                this.vehicleInfo.ModelName = modelInfo.ModelName;
                this.vehicleInfo.FuelType = modelInfo.FuelType;
                this.vehicleInfo.DriverSide = modelInfo.DriverLeftRight
                this.setFuelTankCapacity(modelInfo.FuelTankCapacity);
                this.setDisplacement(modelInfo.Displacement);
                this.setVehicleWidth(modelInfo.ADASWidth);
                this.setHoodLength(modelInfo.ADASHoodLength);
                this.setWeight(modelInfo.Weight);
            },
            handleSelectDriver(data) {
                this.vehicleInfo.DriverIds = data.map((item) => {
                    return item.Id;
                });
            },
            getImagePath(path) {
                return this.$baseURL + path + "?t=" + new Date().getTime();
            },
            selectLicense(imgfiles) {
                if (imgfiles)
                    this.vehicleInfo.LicenseBase64 = imgfiles;
                else
                    this.vehicleInfo.LicenseBase64 = "";
            },
            setFuelTankCapacity(fuelTankCapacity) {
                if (fuelTankCapacity) {
                    this.vehicleInfo.FuelTankCapacity =fuelTankCapacity;
                    this.FuelTankCapacityShow = numRound(this.$unit.convertLiterUnit(fuelTankCapacity,'Metric',this.currentUnitType), 1);
                }
            },
            setDisplacement(displacement) {
                if (displacement) {
                    this.vehicleInfo.Displacement = displacement
                    this.DisplacementShow = numRound(this.$unit.convertDisplacementByUnit(displacement,'Metric',this.currentUnitType), 1);
                }
            },

            setVehicleWidth(vehicleWidth) {
                if (vehicleWidth) {
                    this.vehicleInfo.VehicleWidth = vehicleWidth;
                    this.VehicleWidthShow = numRound(this.$unit.convertCmByUnit(vehicleWidth * 100,'Metric',this.currentUnitType), 1);
                }
            },
            setHoodLength(hoodLength) {
                if (hoodLength) {
                    this.vehicleInfo.HoodLength = hoodLength;
                    this.HoodLengthShow = numRound(this.$unit.convertCmByUnit(hoodLength * 100,'Metric',this.currentUnitType), 1);
                }
            },
            setWeight(value) {
                var min = numRound(this.$unit.getTNum(1.8), 1),
                    max = numRound(this.$unit.getTNum(3.5), 1);
                if (min == undefined || max == undefined)
                    this.vehicleInfo.Weight ='';
                switch (value) {
                    case 10:
                        this.vehicleInfo.Weight = this.$t('vehicle.under') + min + this.$t('vehicle.t');
                        break;
                    case 20:
                        this.vehicleInfo.Weight = min + ' ~ ' + max + this.$t('vehicle.t');
                        break;
                    case 30:
                        this.vehicleInfo.Weight = this.$t('vehicle.over') + max + this.$t('vehicle.t');
                        break;
                }
            }
        },
        created() {
            this.devicePlatform = this.$route.query.model;
            this.isM810OrM820 = (this.devicePlatform === 'M810' || this.devicePlatform === 'M820');
        }
    }
</script>

<style lang="stylus" scoped>
    @import "../../../assets/css/management.styl";

    .management-table .text-value-input, .management-table .text-value-input-append, .management-table .text-value-input-extra {
        max-width 280px
        width 100%
    }
    .management-table .language-select-class{
        width 150px !important
    }

    @media only screen and (max-device-width: 1440px) {
        .management-table .text-value-input, .management-table .text-value-input-append {
            max-width 250px
            width 100%
        }

        .management-table .text-value-input-extra {
            width 150px
        }
    }

    .license-area {
        margin: 0 !important;
        padding: 20px 0 20px 0;
    }

    .driver-area {
        margin: 0 !important;
    }

    >>> .el-form-item
        display flex
        align-items center
        .el-form-item__content
            margin-left 0 !important
            line-height normal
            flex: 1
        .el-form-item__label
            line-height normal
        .el-form-item__error
            width 300px

    .uppercase-input >>> .el-input__inner {
        text-transform: uppercase
    }

    >>> .el-switch__core {
        background $color_black_third
    }

</style>
